import { UnitTypeEnum } from "@gtpl/shared-models/masters";
import { WorkStationsDropDown } from "@gtpl/shared-models/production-management";
import appSettings from "apps/services/config";
import { EntityRepository, getManager, Repository } from "typeorm";
import { WorkStations } from "../workstations.entity";

@EntityRepository(WorkStations)
export class WorkStationsRepository extends Repository<WorkStations> {

    async getWorkStationsForCategory(category: number, unitId: number): Promise<WorkStationsDropDown[]> {
        // const workstations: WorkStationsDropDown[] = await this.createQueryBuilder('workstations')
        //     .select('workstation_id as workstationId, workstation')
        //     .where(`workstation_category_id = ${category} and unit_id= '${unitId}'`)
        //     .getRawMany();

        const manager = getManager();
        var dataQuery = `SELECT workstation_id as workstationId, workstation FROM ` + appSettings.production_db + `.workstations WHERE workstation_category_id = '${category}' and unit_id= '${unitId}' `
        const workstations = await manager.query(dataQuery);
        return workstations;
    }

}